import { parseStatusesFromQueryParam } from '@helpers/parseStatusesFromQueryParam';
import { RECORDING_SESSION_TYPES, TRecordingSessionType } from 'app/types/enums/recordingSessionTypes';

const ALLOWED_MEETING_TYPES = new Set<string>(RECORDING_SESSION_TYPES.map((sessionType) => sessionType.value));

export const parseMeetingTypesFromQueryParam = (value: string | null): TRecordingSessionType[] =>
  parseStatusesFromQueryParam(value).filter((v): v is TRecordingSessionType => ALLOWED_MEETING_TYPES.has(v));
